/* eslint-disable no-unused-vars */
const apiUrl = 'http://ec2-54-180-141-120.ap-northeast-2.compute.amazonaws.com:3000'
const hostUrl = 'http://kkotgil.s3-website.ap-northeast-2.amazonaws.com'

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = {
    apiUrl: apiUrl,
    hostUrl: hostUrl
  }
}